<template>
  <BModal
    :id="id"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    scrollable
    size="lg"
    @shown="getSKHistory"
  >
    <div class="flex items-center justify-between">
      <h1 class="mb-[.5rem] text-2xl text-black">
        Riwayat SK
      </h1>
      <feather-icon
        icon="XIcon"
        class="cursor-pointer"
        @click="closeModal"
      />
    </div>
    <p class="mb-[1rem]">
      Berikut adalah daftar SK yang pernah di-generate untuk partner ini.
    </p>
    <BOverlay
      id="scroll"
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
      class="max-h-[60vh] overflow-y-auto"
    >
      <BTable
        :items="items"
        :fields="fields"
        class="bordered-body-b-table"
        responsive
      >
        <template #cell(sk_number)="data">
          <span class="text-black">{{ data.item.sk_number }}</span>
        </template>
        <template #cell(apply_at)="data">
          <span class="text-black">{{ data.item.published_date ? DATE_NUMBER_SLASH(data.item.published_date) : '-' }}</span>
        </template>
        <template #cell(generate_at)="data">
          <span class="text-black">{{ getGenerateAt(data.item.generated_date).date || '' }}</span>
          <br>
          <span class="text=[#737373]">{{ getGenerateAt(data.item.generated_date).time || '' }} WIB</span>
        </template>
        <template #cell(action)="data">
          <BButton
            variant="link"
            class="box-shadow"
            @click="() => downloadSK(data.item)"
          >
            <div class="inline-block flex items-center">
              <feather-icon
                icon="DownloadIcon"
                size="16"
                class="text-[#737373]"
              />
              <span class="ms-[.75rem] underline text-black font-medium">Unduh</span>
            </div>
          </BButton>
        </template>
      </BTable>
    </BOverlay>
  </BModal>
</template>

<style scoped>
.btn-outline-primary,
.btn-primary,
.btn-light,
.btn-secondary,
.btn-link {
  border-radius: 10px;
}

.box-shadow {
  box-shadow:
  inset 0 1px 0 #ddd,
  inset 0 -1px 0 #ddd,
  inset 1px 0 0 #ddd,
    inset -1px 0 0 #ddd;;
}
</style>

<script>
import { DATE_NUMBER_SLASH } from '@/libs/filterDate'
import { komtimAxiosIns } from '@/libs/axios'
import { downloadFileFromBlob } from '@/libs/downloadFile'
import moment from 'moment'
import { showError, tableSKHistory } from './config'

export default {
  props: {
    id: {
      type: String,
      default: 'sk-history-modal',
    },
    partnerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      fields: tableSKHistory,
      items: [],
      loading: false,
      DATE_NUMBER_SLASH,
    }
  },
  methods: {
    getGenerateAt(stringDate) {
      if (!stringDate) return { date: '', time: '' }
      const d = moment.parseZone(stringDate)
      return {
        date: d.format('DD/MM/YYYY'),
        time: d.format('HH:mm:ss'),
      }
    },
    closeModal() {
      this.$bvModal.hide(this.id)
    },
    async getSKHistory() {
      try {
        const url = `/v1/partner_assignments/${this.partnerId}/sks`
        const { data: { data } } = await komtimAxiosIns.get(url)
        this.items = data
      } catch (error) {
        showError(error)
      }
    },
    async downloadSK({ id }) {
      try {
        const url = `/v1/partner_assignments/sks/${id}/download`
        const response = await komtimAxiosIns.get(url, {
          responseType: 'blob',
        })
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const fileName = `SK_${id}.pdf`
        downloadFileFromBlob(blob, fileName)
      } catch (error) {
        showError(error)
      }
    },
  },
}
</script>
